import { render, staticRenderFns } from "./ScreensFilter.vue?vue&type=template&id=f37dd2ac"
import script from "./ScreensFilter.vue?vue&type=script&lang=js"
export * from "./ScreensFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports